/* ==========================================================================
   The Great British Shop - product reviews
   --------------------------------------------------------------------------
   Everything this file does is optional. The stars, the words, the reply and
   the Google structured data are already in the HTML before this runs. Delete
   this file and the page still reads correctly, it just stops offering Show
   more and the write-a-review form.

   Three jobs:
     1. Show more reviews, one page at a time.
     2. Ask whether the person reading is allowed to write one, and only when
        they open the panel, so a normal visit costs nothing.
     3. Send the review.

   Rules it keeps:
     no library, no CDN, nothing outside this file
     every request has a timeout, and a failed request is silent
     text from the API goes in with textContent, never innerHTML, so a review
       containing a stray angle bracket stays a review
   ========================================================================== */
(function () {
  'use strict';

  var TIMEOUT = 8000;
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var XLINK = 'http://www.w3.org/1999/xlink';
  var WORDS = ['', 'Poor', 'Not great', 'All right', 'Good', 'Excellent'];

  /* ---------------------------------------------------------------- utils */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function clamp(n, lo, hi) {
    n = parseFloat(n);
    if (isNaN(n)) return lo;
    return Math.min(hi, Math.max(lo, n));
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(String(iso).length === 10 ? iso + 'T12:00:00Z' : iso);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function fetchJSON(url, opts) {
    opts = opts || {};
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT);
    if (ctrl) opts.signal = ctrl.signal;
    return fetch(url, opts)
      .then(function (res) {
        clearTimeout(timer);
        return res.json().then(function (body) {
          if (!res.ok || body.ok === false) {
            var err = new Error(body.error || ('HTTP ' + res.status));
            err.body = body;
            err.status = res.status;
            throw err;
          }
          return body;
        });
      })
      .catch(function (e) { clearTimeout(timer); throw e; });
  }

  /* ------------------------------------------------------------- the star */
  /* Mirrors snippets/gbs-review-stars.liquid exactly. If one changes the
     other has to change with it, or a review added by Show more will not look
     like the ones above it. */

  function starSvg() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'gbs-rv-star');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var use = document.createElementNS(SVG_NS, 'use');
    use.setAttribute('href', '#gbs-rv-star');
    use.setAttributeNS(XLINK, 'xlink:href', '#gbs-rv-star');
    svg.appendChild(use);
    return svg;
  }

  function starRow(rating, label) {
    var r = clamp(rating, 0, 5);
    var wrap = el('span', 'gbs-rv-stars');
    wrap.style.setProperty('--gbs-rv-fill', (r * 20).toFixed(2) + '%');
    if (label) {
      wrap.setAttribute('role', 'img');
      wrap.setAttribute('aria-label', label);
    } else {
      wrap.setAttribute('aria-hidden', 'true');
    }
    ['off', 'on'].forEach(function (which) {
      var row = el('span', 'gbs-rv-stars__row gbs-rv-stars__row--' + which);
      row.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 5; i++) row.appendChild(starSvg());
      wrap.appendChild(row);
    });
    return wrap;
  }

  /* ----------------------------------------------------------- one review */
  /* Mirrors snippets/gbs-review-card.liquid. */

  function verifiedTag() {
    var s = el('span', 'gbs-rv-verified');
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var p = document.createElementNS(SVG_NS, 'path');
    p.setAttribute('d', 'M10 0a10 10 0 1 0 0 20A10 10 0 0 0 10 0Zm-1.1 14.2-4-4 1.4-1.4 2.6 2.6 5.4-5.4 1.4 1.4-6.8 6.8Z');
    svg.appendChild(p);
    s.appendChild(svg);
    s.appendChild(document.createTextNode(' Verified buyer'));
    return s;
  }

  function replyMark() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'gbs-rv-reply__mark');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    ['M6.2 3.6 2.6 7.2l3.6 3.6', 'M2.6 7.2h6.6a3.6 3.6 0 0 1 3.6 3.6v1.6'].forEach(function (d) {
      var p = document.createElementNS(SVG_NS, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  function paragraphs(host, text) {
    String(text || '').split(/\n{2,}/).forEach(function (chunk) {
      var p = el('p');
      chunk.split(/\n/).forEach(function (line, i) {
        if (i) p.appendChild(document.createElement('br'));
        p.appendChild(document.createTextNode(line));
      });
      host.appendChild(p);
    });
  }

  function reviewNode(r) {
    var li = el('li', 'gbs-rv-item');
    var art = el('article');
    var rating = clamp(r.rating, 0, 5);

    var head = el('div', 'gbs-rv-item__head');
    var starsWrap = el('span', 'gbs-rv-item__stars');
    starsWrap.appendChild(starRow(rating, ''));
    head.appendChild(starsWrap);
    head.appendChild(el('span', 'gbs-rv-sr', 'Rated ' + rating + ' out of 5'));

    if (r.published_at) {
      var t = el('time', 'gbs-rv-item__date', fmtDate(r.published_at));
      t.setAttribute('datetime', r.published_at);
      head.appendChild(t);
    }
    if (r.title) head.appendChild(el('h3', 'gbs-rv-item__title', r.title));
    art.appendChild(head);

    var body = el('div', 'gbs-rv-item__body');
    paragraphs(body, r.body);
    art.appendChild(body);

    var foot = el('div', 'gbs-rv-item__foot');
    foot.appendChild(el('span', 'gbs-rv-item__author', r.author || 'A customer'));
    if (r.author_location) {
      foot.appendChild(el('span', 'gbs-rv-item__sep', '·'));
      foot.appendChild(el('span', null, r.author_location));
    }
    if (r.verified) {
      foot.appendChild(el('span', 'gbs-rv-item__sep', '·'));
      foot.appendChild(verifiedTag());
    }
    art.appendChild(foot);

    if (r.reply && r.reply.body) {
      var rep = el('div', 'gbs-rv-reply');
      var rh = el('div', 'gbs-rv-reply__head');
      rh.appendChild(replyMark());
      rh.appendChild(el('span', 'gbs-rv-reply__who', 'The Great British Shop replied'));
      if (r.reply.published_at) {
        var rt = el('time', 'gbs-rv-reply__when', fmtDate(r.reply.published_at));
        rt.setAttribute('datetime', r.reply.published_at);
        rh.appendChild(rt);
      }
      rep.appendChild(rh);
      var rb = el('div', 'gbs-rv-reply__body');
      paragraphs(rb, r.reply.body);
      rep.appendChild(rb);
      art.appendChild(rep);
    }

    li.appendChild(art);
    return li;
  }

  /* ------------------------------------------------------------ the block */

  function setUp(root) {
    var api = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
    var productId = root.getAttribute('data-product-id');
    var handle = root.getAttribute('data-handle');
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 6;
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var shown = parseInt(root.getAttribute('data-shown'), 10) || 0;
    var wantFallback = root.getAttribute('data-fallback') === '1';
    var page = parseInt(root.getAttribute('data-page'), 10) || 1;

    var list = root.querySelector('[data-gbs-rv-list]');
    var more = root.querySelector('[data-gbs-rv-more]');
    var moreBtn = root.querySelector('[data-gbs-rv-more-btn]');
    var moreNote = root.querySelector('[data-gbs-rv-more-note]');

    function paint() {
      if (!more) return;
      if (moreNote) moreNote.textContent = 'Showing ' + shown + ' of ' + total;
      more.hidden = shown >= total;
    }

    /* ---------------------------------------------------- 1. show more --- */
    if (moreBtn && list && !moreBtn.dataset.gbsRvMoreReady) {
      moreBtn.dataset.gbsRvMoreReady = '1';
      moreBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (moreBtn.dataset.busy) return;
        moreBtn.dataset.busy = '1';
        var was = moreBtn.textContent;
        moreBtn.textContent = 'Loading';

        fetchJSON(api + '/api/reviews/v1/product/' + encodeURIComponent(productId) +
                  '?page=' + (page + 1) + '&per_page=' + perPage)
          .then(function (data) {
            page += 1;
            var added = 0;
            (data.reviews || []).forEach(function (r) {
              list.appendChild(reviewNode(r));
              added += 1;
            });
            shown += added;
            if (data.aggregate && typeof data.aggregate.count === 'number') total = data.aggregate.count;
            if (added === 0) total = shown;
            moreBtn.textContent = was;
            delete moreBtn.dataset.busy;
            paint();
            /* send the reader to the first thing they have not read */
            var first = list.children[shown - added];
            if (first) {
              first.setAttribute('tabindex', '-1');
              first.focus({ preventScroll: true });
            }
          })
          .catch(function () {
            /* the page never traps anyone: fall back to the link's own href */
            window.location.href = moreBtn.href;
          });
      });
    }

    /* ------------------------------------- 2. reviews not synced yet ----- */
    var empty = root.querySelector('[data-gbs-rv-empty]');
    if (empty && wantFallback && total === 0) {
      fetchJSON(api + '/api/reviews/v1/product/' + encodeURIComponent(productId) +
                '?page=1&per_page=' + perPage)
        .then(function (data) {
          var rs = data.reviews || [];
          var agg = data.aggregate || {};
          if (!rs.length || !agg.count) return;
          buildFromScratch(root, empty, agg, rs, api, handle);
          root.setAttribute('data-page', parseInt(data.page, 10) || 1);
          root.setAttribute('data-per-page', parseInt(data.per_page, 10) || perPage);
          setUp(root);
        })
        .catch(function () { /* the empty state is a perfectly good page */ });
    }

    /* ---------------------------------------------- 3. write a review --- */
    var write = root.querySelector('[data-gbs-rv-write]');
    if (write) wireForm(write, api, productId, handle);

    paint();
  }

  /* Builds the summary and list when Shopify had nothing and the site did.
     Deliberately does NOT write structured data: Google is served from the
     HTML Shopify sends, never from something a script drew afterwards. */
  function buildFromScratch(root, empty, agg, reviews, api, handle) {
    var rating = clamp(agg.rating, 0, 5);
    var count = parseInt(agg.count, 10) || reviews.length;
    var word = count === 1 ? 'review' : 'reviews';

    var grid = el('div', 'gbs-rv__grid');
    var left = el('div');
    var summary = el('div', 'gbs-rv-summary');
    summary.setAttribute('data-gbs-rv-summary', '');

    var score = el('div', 'gbs-rv-score');
    var val = el('p', 'gbs-rv-score__value', rating.toFixed(1));
    val.appendChild(el('span', 'gbs-rv-score__out-of', '/5'));
    score.appendChild(val);
    var srow = el('span', 'gbs-rv-score__stars');
    srow.appendChild(starRow(rating, 'Rated ' + rating.toFixed(1) + ' out of 5 from ' + count + ' customer ' + word));
    score.appendChild(srow);
    summary.appendChild(score);

    var cnt = el('p', 'gbs-rv-score__count');
    cnt.appendChild(document.createTextNode('From '));
    cnt.appendChild(el('b', null, String(count)));
    cnt.appendChild(document.createTextNode(' ' + word + ' by people who bought it'));
    summary.appendChild(cnt);
    left.appendChild(summary);

    var write = root.querySelector('[data-gbs-rv-write]');
    if (write) left.appendChild(write);

    var right = el('div');
    var ul = el('ul', 'gbs-rv-list');
    ul.setAttribute('role', 'list');
    ul.setAttribute('data-gbs-rv-list', '');
    reviews.forEach(function (r) { ul.appendChild(reviewNode(r)); });
    right.appendChild(ul);

    var more = el('div', 'gbs-rv-more');
    more.setAttribute('data-gbs-rv-more', '');
    more.hidden = reviews.length >= count;
    var moreBtn = el('a', 'gbs-rv-btn gbs-rv-btn--quiet', 'Show more reviews');
    moreBtn.setAttribute('data-gbs-rv-more-btn', '');
    moreBtn.href = api + '/reviews/' + encodeURIComponent(handle);
    var moreNote = el('span', 'gbs-rv-more__note', 'Showing ' + reviews.length + ' of ' + count);
    moreNote.setAttribute('data-gbs-rv-more-note', '');
    moreNote.setAttribute('aria-live', 'polite');
    more.appendChild(moreBtn);
    more.appendChild(moreNote);
    right.appendChild(more);

    grid.appendChild(left);
    grid.appendChild(right);

    var solo = root.querySelector('.gbs-rv__solo');
    var target = solo || empty;
    target.parentNode.replaceChild(grid, target);
    root.classList.remove('gbs-rv--empty');
    root.setAttribute('data-total', count);
    root.setAttribute('data-shown', reviews.length);

    var head = root.querySelector('.gbs-rv__head');
    if (head && !head.querySelector('[data-gbs-rv-headcount]')) {
      var hc = el('span', 'gbs-rv__title-count', count + ' ' + word);
      hc.setAttribute('data-gbs-rv-headcount', '');
      head.appendChild(hc);
    }
  }

  /* ------------------------------------------------------------ the form */

  function note(kind, text) {
    var n = el('div', 'gbs-rv-note' + (kind ? ' gbs-rv-note--' + kind : ''));
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var p = document.createElementNS(SVG_NS, 'path');
    p.setAttribute('d', kind === 'good'
      ? 'M10 0a10 10 0 1 0 0 20A10 10 0 0 0 10 0Zm-1.1 14.2-4-4 1.4-1.4 2.6 2.6 5.4-5.4 1.4 1.4-6.8 6.8Z'
      : 'M10 0a10 10 0 1 0 0 20A10 10 0 0 0 10 0Zm1 7H9V5h2Zm0 8H9V9h2Z');
    svg.appendChild(p);
    n.appendChild(svg);
    n.appendChild(el('span', null, text));
    return n;
  }

  function wireForm(write, api, productId, handle) {
    if (write.dataset.gbsRvFormReady) return;
    write.dataset.gbsRvFormReady = '1';
    var start = write.querySelector('[data-gbs-rv-state="start"]');
    var message = write.querySelector('[data-gbs-rv-state="message"]');
    var form = write.querySelector('[data-gbs-rv-form]');
    var rateSet = write.querySelector('[data-gbs-rv-rateset]');
    var said = write.querySelector('[data-gbs-rv-said]');
    var errBox = write.querySelector('[data-gbs-rv-error]');
    var asked = false;

    /* the chosen star, said in words, and mirrored onto the set for browsers
       too old for :has */
    if (rateSet) {
      rateSet.addEventListener('change', function () {
        var picked = rateSet.querySelector('.gbs-rv-rate__input:checked');
        if (!picked) return;
        rateSet.setAttribute('data-rating', picked.value);
        if (said) said.textContent = WORDS[parseInt(picked.value, 10)] || '';
      });
    }

    function show(node) {
      if (start) start.hidden = true;
      if (message) {
        message.hidden = false;
        message.textContent = '';
        message.appendChild(node);
      }
    }

    function askedAndAllowed(data) {
      if (start) start.hidden = true;
      if (message) { message.hidden = true; message.textContent = ''; }
      if (!form) return;
      form.hidden = false;
      var nameField = form.querySelector('[name=display_name]');
      if (nameField && data.display_name && !nameField.value) nameField.value = data.display_name;
      form.dataset.token = data.token || '';
    }

    function ask() {
      if (asked) return;
      asked = true;

      var loading = el('p', null, 'Just checking your orders.');
      show(loading);

      fetchJSON(api + '/api/reviews/v1/eligibility?product_id=' + encodeURIComponent(productId), {
        credentials: 'include',
        headers: { Accept: 'application/json' }
      })
        .then(function (data) {
          if (data.eligible) return askedAndAllowed(data);

          var wrap = el('div');
          if (!data.signed_in) {
            wrap.appendChild(el('p', null,
              'Only customers who have bought this can review it. Sign in and we will check your orders for you.'));
            var a = el('a', 'gbs-rv-btn', 'Sign in to write a review');
            a.href = api + '/reviews/new?product=' + encodeURIComponent(handle) +
                     '&return=' + encodeURIComponent(window.location.href);
            wrap.appendChild(a);
          } else if (data.reason === 'already_reviewed') {
            wrap.appendChild(note('good', 'You have already reviewed this one. Thank you.'));
          } else if (data.reason === 'too_soon') {
            wrap.appendChild(el('p', null,
              data.eligible_from
                ? 'Your order is on its way. You will be able to review this from ' + fmtDate(data.eligible_from) + '.'
                : 'Your order is on its way. You will be able to review this a few days after it arrives.'));
          } else {
            wrap.appendChild(el('p', null,
              'Reviews here are written by customers who have bought the product, and we could not find this one in your orders. If that looks wrong, please get in touch and we will sort it out.'));
          }
          show(wrap);
        })
        .catch(function () {
          /* the site did not answer. Hand back the link that always works. */
          var wrap = el('div');
          wrap.appendChild(el('p', null,
            'We could not check your orders just now. Please try again in a moment.'));
          var a = el('a', 'gbs-rv-btn', 'Write a review on your account');
          a.href = api + '/reviews/new?product=' + encodeURIComponent(handle);
          wrap.appendChild(a);
          show(wrap);
          asked = false;
        });
    }

    /* nothing is asked until the panel is opened, so a normal visit is free */
    write.addEventListener('toggle', function () { if (write.open) ask(); });

    if (!form) return;

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var picked = form.querySelector('.gbs-rv-rate__input:checked');
      var body = form.querySelector('[name=body]');
      var title = form.querySelector('[name=title]');
      var name = form.querySelector('[name=display_name]');
      var btn = form.querySelector('[data-gbs-rv-submit]');

      function fail(msg, focus) {
        if (!errBox) return;
        errBox.hidden = false;
        errBox.className = 'gbs-rv-note gbs-rv-note--bad';
        errBox.textContent = '';
        var svg = note('bad', msg);
        while (svg.firstChild) errBox.appendChild(svg.firstChild);
        if (focus) focus.focus();
      }

      if (!picked) return fail('Please choose a star rating first.', form.querySelector('.gbs-rv-rate__input'));
      if (!body || !body.value.trim()) return fail('Please write a line or two about it.', body);

      if (errBox) errBox.hidden = true;
      if (btn) { btn.disabled = true; btn.textContent = 'Sending'; }

      fetchJSON(api + '/api/reviews/v1/submit', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          token: form.dataset.token || '',
          product_id: productId,
          rating: parseInt(picked.value, 10),
          title: title ? title.value.trim() : '',
          body: body.value.trim(),
          display_name: name ? name.value.trim() : ''
        })
      })
        .then(function () {
          var done = el('div');
          done.appendChild(note('good',
            'Thank you. Your review goes on the site once we have read it, so give it a day or two.'));
          form.hidden = true;
          if (message) { message.hidden = false; message.textContent = ''; message.appendChild(done); }
        })
        .catch(function (e) {
          if (btn) { btn.disabled = false; btn.textContent = 'Send my review'; }
          var msg = (e && e.body && e.body.message) ||
            'We could not send that just now. Please try again in a moment.';
          fail(msg);
        });
    });
  }

  /* ---------------------------------------------------------------- boot */

  function boot() {
    var roots = document.querySelectorAll('[data-gbs-rv]');
    for (var i = 0; i < roots.length; i++) {
      try { setUp(roots[i]); } catch (e) { /* never take the page down */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
